import React from 'react';
import { observer } from 'owa-mobx-react';
import classNames from 'owa-classnames';
import { appModule, fullBleed } from './AppModuleContainer.scss';
import { isCapabilityEnabled } from 'owa-capabilities';
import { bleedThroughCapability } from 'owa-capabilities-definitions/lib/bleedThroughCapability';

export interface AppModuleContainerProps {
    children: React.ReactNode;
}
const AppModuleContainer: React.FunctionComponent<AppModuleContainerProps> = observer(
    function AppModuleContainer({ children }: AppModuleContainerProps) {
        return (
            <div
                className={classNames(
                    appModule,
                    isCapabilityEnabled(bleedThroughCapability) && fullBleed
                )}
            >
                {children}
            </div>
        );
    },
    'AppModuleContainer'
);

export { AppModuleContainer };
